<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">品種検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          v-permit.SHARP_PRODUCT_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn to="/M0231/new" v-permit.SHARP_PRODUCT_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_PRODUCT_EDIT
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          v-permit.SHARP_PRODUCT_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field clearable label="品種CD" v-model="query.code" />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="品種名" v-model="query.name" />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="品種名英文"
                v-model="query.englishName"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field clearable label="機種名称" v-model="query.model" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td :key="head.text" v-for="head in headers">
            {{ props.item[head.value] }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [
        { text: '品種CD', value: 'code', sortable: false },
        { text: '品種名', value: 'name', sortable: false },
        { text: '品種名英文', value: 'englishName', sortable: false },
        { text: '機種名称', value: 'model', sortable: false },
        { text: '品種グループ', value: 'productGroupName', sortable: false },
        {
          text: '物流社内品番ありEIAJに表示',
          value: 'showLogisticsSku',
          sortable: false,
        },
      ],
    }
  },

  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/products', this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.$router.push({
        path: 'M0231/edit',
        query: { id: this.selected[0].code },
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map((i) => {
              return this.$http.delete(`/products/${i.code}`).catch()
            })
          ).then(() => {
            this.selected = []
            this.load()
          })
        }
      )
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  mounted() {
    this.$loadParams()
  },
}
</script>
